var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "my-3 apartment-ticket" },
    [
      _vm.isLoading
        ? _c("v-progress-linear", {
            attrs: { indeterminate: true, height: "2", color: "secondary" }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("v-card-title", { attrs: { "primary-title": "" } }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "h4",
            {
              staticClass:
                "headline mb-0 primary--text apartment-ticket--border-bottom-2"
            },
            [
              _vm._v(
                _vm._s(_vm.$t(_vm.lblSetting.blockTicketInProcess)) + "\n      "
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row wrap" },
        [
          _vm._l(_vm.blockApartmentInProcessTickets, function(ticket) {
            return _c("list-item", {
              key: "in-process-tk-" + ticket.id,
              attrs: { ticket: ticket }
            })
          }),
          _vm._v(" "),
          _vm.blockApartmentInProcessTickets.length === 0
            ? _c("no-record")
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-md-center" },
        [
          _c("base-modal-submit-btn", {
            attrs: { title: "nouveau ticket", icon: "add" },
            on: { record: _vm.handleCreateTicket }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "base-modal",
        {
          attrs: {
            "create-another": _vm.dtCreateAnother,
            loading: _vm.dtIsRecording,
            "action-position": "center",
            icon: "icon-newticket",
            "before-close": _vm.handleBeforeModalClose,
            "submit-btn-title": _vm.$t(_vm.lblSetting.ticketCreateNew),
            "hide-default-action": true,
            title: _vm.lblSetting.ticketCreate,
            "max-width": _vm.maxWidth,
            "create-another-label": _vm.$t(
              _vm.lblSetting.ticketCreateAnotherTicket
            )
          },
          on: {
            "update:createAnother": function($event) {
              _vm.dtCreateAnother = $event
            },
            onRecord: _vm.handleSave
          },
          model: {
            value: _vm.dtTicketModalVisible,
            callback: function($$v) {
              _vm.dtTicketModalVisible = $$v
            },
            expression: "dtTicketModalVisible"
          }
        },
        [
          _c("ticket-modal", {
            attrs: {
              attachments: _vm.dtAttachments,
              "current-tenant": _vm.dtCurrentTenant
            },
            on: {
              "update:attachments": function($event) {
                _vm.dtAttachments = $event
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03b80af8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03b80af8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/block/components/block-apartment-tickets/template.html
// module id = null
// module chunks = 